import React from 'react';
import { CDIsotype, BrandWordmark } from './BrandMark';
type LogoProps = {
  showWordmark?: boolean;
  showTagline?: boolean;
  size?: 'sm' | 'md' | 'lg';
  tone?: 'ink' | 'inverse';
  className?: string;
};
const MARK_SIZE = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-14 w-14'
} as const;
export function Logo({
  showWordmark = true,
  showTagline = false,
  size = 'sm',
  tone = 'ink',
  className = ''
}: LogoProps) {
  return <a href="#inicio" aria-label="Creativo Digital — inicio" className={`group inline-flex items-center gap-3 transition-opacity duration-300 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric/40 focus-visible:ring-offset-4 ${tone === 'inverse' ? 'text-white' : 'text-ink'} ${className}`} data-id="element-181" data-mp="mtdwkpyzr1cj">
      <CDIsotype className={MARK_SIZE[size]} data-id="element-182" data-mp="2yi5ef4nobfw5" />
      {showWordmark && <>
          <span aria-hidden="true" className={`h-7 w-px ${tone === 'inverse' ? 'bg-white/20' : 'bg-ink/10'}`} data-id="element-183" data-mp="32kicd6w6i9id" />
          <BrandWordmark size={size} showTagline={showTagline} tone={tone} data-id="element-184" data-mp="19vwu21wmhckz" />
        </>}
    </a>;
}